import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, VStack, Text, Button, Icon } from "@chakra-ui/react";
import { CheckCircleIcon } from "@chakra-ui/icons";
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";

const SubscriptionSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");

  const [success, setSuccess] = useState(false);

  useEffect(() => {
    try {
      api
        .get(`${API_BASE}/api/payment/user-subscription?sessionId=${sessionId}`)
        .then((res) => {
          if (res.status == 200) {
            setSuccess(true);
          }
        });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }, [sessionId]);

  const onContinue = () => {
    navigate("/student-profile/assignment");
  };

  return (
    <>
      {success && (
        <Box
          w="100%"
          maxW="400px"
          mx="auto"
          mt="20"
          mb="8"
          p="6"
          boxShadow="lg"
          borderRadius="md"
          bg="white"
        >
          <VStack spacing={4} align="center">
            <Icon as={CheckCircleIcon} w={12} h={12} color="green.500" />
            <Text fontSize="2xl" fontWeight="bold">
              Subscription Successful!
            </Text>
            <Text textAlign="center" color="gray.600">
              Thank you for your subscription. Your status will be updated once
              the transaction has been completed successfully.
            </Text>
            <Button colorScheme="green" onClick={onContinue} w="full">
              Start Learning
            </Button>
          </VStack>
        </Box>
      )}
    </>
  );
};

export default SubscriptionSuccess;
